<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <!-- <transition name="router-fade" mode="out-in"> -->
      <keep-alive :include="['goodsList', 'order']">
        <router-view />
      </keep-alive>
    <!-- </transition> -->
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
/* #app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
} */
/* .router-fade-enter-active, .router-fade-leave-active {
    transition: opacity .3s ease, transform 0.5s ease;
} */
/* .router-fade-enter, .router-fade-leave-active { */
    /* opacity: 0.1; */
    /* transform: rotate(7deg) */
    /* transform: scale(0.9); */
    /* transform: skew(5deg); */
    /* transform: translateX(50px) */
/* } */
</style>



// WEBPACK FOOTER //
// src/App.vue